import { useState } from "react";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { http, track } from "@/advisor/api";

export const useBusinessSubmit = () => {
  const { state, update, meta } = useAdvisor();
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    let business = meta?.business_types.find((b) => b.key === state.chipKey);
    if (!business || business.key === "other") {
      business = (await http.post("/advisor/detect", { text: state.businessText }).catch(() => null))?.data
        || meta?.business_types.find((b) => b.key === "other") || { key: "other", label: "Digər", icon: "Sparkles" };
    }
    setLoading(false);
    track("business", { business_type: business.key });
    const step = business.key === "tiktok" ? "tiktok" : "goals";
    update({ business, goals: [], tools: [], tiktokGames: [], step });
    return step;
  };

  return { submit, loading };
};
